export const combinedRate = (preset)=>preset.components.reduce((sum, c)=>sum + (parseFloat(c.rate) || 0), 0);
export const formatPercent = (rate)=>{
    const n = typeof rate === 'string' ? parseFloat(rate) : rate;
    if (Number.isNaN(n)) return '0.00%';
    return "".concat(n.toFixed(2), "%");
};
